import { Filter } from "@/common/model/Filter";
import { Nullable } from "@/general/custom-types/CustomTypes";

export class DataLoggerFilter extends Filter {
  identifier?: Nullable<string>;
  customer?: Nullable<number[]>;
  facility?: Nullable<number[]>;
  country?: Nullable<string>;

  constructor(
    identifier?: Nullable<string>,
    client?: Nullable<number[]>,
    facility?: Nullable<number[]>,
    country?: Nullable<string>
  ) {
    super("data-logger-filter");
    this.identifier = identifier;
    this.customer = client;
    this.facility = facility;
    this.country = country;
  }

  clear(): void {}

  toQueryParam(): string {
    let query: string = "";
    if (this.customer && this.customer.length > 0) {
      query += `&customer=${this.customer}`;
    }
    if (this.facility && this.facility.length > 0) {
      query += `&facility=${this.facility}`;
    }
    if (this.country && this.country !== "") {
      query += `&country=${this.country}`;
    }
    if (this.identifier && this.identifier !== "") {
      query += `&identifier=${this.identifier}`;
    }
    return query;
  }
}
